export default __webpack_public_path__ + "static/media/pattern-002-11.ef05d92b.jpg";